import { getAccountErrorReferralAccounts } from '../selectors/getCurrentSessionAccounts';
import { getOWAConnectedAccount } from 'owa-accounts-store';

export default function getIsAccountRemovalErrorDialogReferral() {
    let accountRemovedOnErrorReferral = null;

    if (getAccountErrorReferralAccounts().length > 0) {
        accountRemovedOnErrorReferral =
            getAccountErrorReferralAccounts().filter(
                userIdentity => !getOWAConnectedAccount(userIdentity)
            ).length > 0;
    }

    return accountRemovedOnErrorReferral;
}
